<style src="css/consultingScheduling.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem">
    <div class="topBox"><span class="back" @click="back()"></span>咨询排班</div>
    <div class="offlineBtn">
      <span
        :class="{ active: scheduleStatus === 0 }"
        @click="changeScheduleStatus(0)"
        >未排班</span
      >
      <span
        :class="{ active: scheduleStatus === 1 }"
        @click="changeScheduleStatus(1)"
        >已排班</span
      >
    </div>
    <div class="mainBox">
      <div class="mainItem" v-for="item in bespeakScheduleDTOList">
        <div
          class="mainTitleBox"
          v-if="item.workId"
          :class="{ active: scheduleStatus === 1 }"
        >
          矫正对象
          <span @click="to(`taskDetail?workId=${item.workId}`)">详情</span>
        </div>
        <div class="infoBox">
          <div class="info">
            <div class="nameBox">
              姓 名： <span class="name">{{ item.userName }}</span>
            </div>
          </div>
          <div class="info">
            <div class="nameBox">
              套餐次数： <span class="name">{{ item.bespeakTimes }}</span>
            </div>
          </div>
          <div
            class="info"
            v-for="(v, i) in item.scaleUserBespeakScheduleList"
            v-if="item.scaleUserBespeakScheduleList !== null"
          >
            第{{ i + 1 }}/{{ item.bespeakTimes }}次：{{ v.bespeakDate | time }}
            <span>{{ v.status | isStatus }}</span>
          </div>
          <div
            class="info"
            v-if="scheduleStatus === 0"
            @click="getDoctorDetail(item.userId, item.bespeakId)"
          >
            添加时间
            <div class="more"></div>
          </div>
        </div>
      </div>
      <no-more-data :noMoreData="noMoreData"></no-more-data>
    </div>
    <div class="maskBox" v-if="mask">
      <div class="boxBlock">
        <div class="titleBox">
          选择时间：<span style="font-size: 0.28rem">（下滑日期查看更多）</span>
        </div>
        <div class="timeBox" v-if="doctorDetail.chatDoctorSchedules">
          <div class="item" v-for="item in doctorDetail.chatDoctorSchedules">
            <div
              class="timeItem"
              :class="{ active: JSON.parse(item.dateValue).length > 0 }"
            >
              {{ item.scheduleDate | week }}
              <span>{{ item.scheduleDate | MM }}</span>
            </div>
            <div
              class="itemBlock"
              :class="{
                active: getDate(item.scheduleDate) + v === bespeakDate,
              }"
              @click="selectDateTime(item.scheduleDate, v)"
              v-for="v in JSON.parse(item.dateValue)"
            >
              {{ v }}
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="inputName">其他时间</div>
          <input type="text" v-model="bespeakDate" placeholder="点击选择时间"
                  @click="isShowCalendar=true">
        </div>
      </div>
    <vue-hash-calendar format="YY-MM-DD hh:mm" :showTodayButton="false" @confirm="confirm" :disabled-date="disabledDate"
                       pickerType="datetime" model="dialog" :visible.sync="isShowCalendar"></vue-hash-calendar>
      <div class="maskBottomBox">
        <div class="maskCancel" @click="cancel()">取消</div>
        <div class="maskSure" @click="doBespeakSchedule()">确认时间</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import footerBox from "components/footer";
import moment from "moment/moment";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      pageIndex: 1,
      pageSize: 25,
      count: 0,
      noMoreData: false,
      isLoading: false,
      bespeakScheduleDTOList: [],
      scheduleStatus: 0,

      isShowCalendar: false,
      mask: false,
      doctorDetail: {},
      bespeakDate: "",
      bespeakId: "",
    };
  },
  components: {
    noMoreData,
    topbar,
    footerBox,
  },
  filters: {
    MM(value) {
      let transTime = moment(value).format("DD");
      return transTime;
    },
    week(value) {
      let time = moment(value).format("dddd");
      let obj = {
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
      };
      return obj[time];
    },
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
    isStatus(v) {
      let arr = ["预约中", "待咨询", "进行中", "已完成", "已取消"];
      return arr[v];
    },
    isTimes(value) {
      let obj = {
        2: "二次",
        4: "四次",
        12: "十二次",
        48: "四十八次",
      };
      if (value) {
        return obj[value];
      }
    },
  },
  computed: {},
  methods: {
    selectDateTime(i, v) {
      if (v.indexOf("已") == -1) {
        this.bespeakDate = this.getDate(i) + v;
      }
    },
     confirm(date) {
      this.bespeakDate = date
    },
    getDate(value) {
      let transTime = moment(value).format("YYYY-MM-DD") + " ";
      return transTime;
    },
    cancel() {
      this.mask = false;
      this.bespeakId = "";
    },
    async getDoctorDetail(id, bespeakId) {
      let obj = {};
      obj.doctorId = localStorage.getItem("doctorId");
      obj.userId = id;
      let data = await getSources(
        "/bear-scale/api/chatDoctor/getDoctorScheduleToBespeak.json",
        obj
      );
      if (data.status === 0) {
        this.doctorDetail = data.doctorSchedule;
        this.bespeakId = bespeakId;
        this.mask = true;
      } else {
        alert(data.msg);
      }
    },
    async doBespeakSchedule(id) {
      let obj = {};
      obj.doctorId = localStorage.getItem("doctorId");
      obj.bespeakId = this.bespeakId;
      obj.bespeakDate = this.bespeakDate + ":00";
      let data = await getSources(
        "/bear-scale/api/scaleGroupComboWork/doBespeakSchedule.json",
        obj
      );
      if (data.status === 0) {
        this.cancel();
        this.init();
      } else {
        alert(data.msg);
      }
    },
    changeScheduleStatus(n) {
      this.scheduleStatus = n;
      this.init();
    },

    init() {
      this.pageIndex = 1;
      this.bespeakScheduleDTOList = [];
      this.noMoreData = false;
      this.getBespeakScheduleList();
    },

    back() {
      history.back();
    },

    to(n) {
      this.$router.push(`/${n}`);
    },
    async getBespeakScheduleList() {
      let data = await getSources(
        "/bear-scale/api/scaleGroupComboWork/getBespeakScheduleList.json",
        {
          doctorId: localStorage.getItem("doctorId"),
          scheduleStatus: this.scheduleStatus,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        }
      );
      if (data.status === 0) {
        this.isLoading = false;
        this.count = data.count;
        this.bespeakScheduleDTOList = [
          ...this.bespeakScheduleDTOList,
          ...data.bespeakScheduleDTOList,
        ];
        if (data.bespeakScheduleDTOList.length === 0) {
          this.noMoreData = true;
        } else {
          console.log(111111);
          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            console.log("显示");
            this.noMoreData = true;
          } else {
            console.log(2);
            this.noMoreData = false;
          }
        }
      } else {
        alert(data.msg);
      }
    },
    handleScroll() {
      //                console.log(11)
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getBespeakScheduleList();
        }
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    this.getBespeakScheduleList();
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
};
</script>



// WEBPACK FOOTER //
// src/components/consultingScheduling.vue